import { XpressPriorityType } from 'app/models';

export class XpressPriorityTypeModel {
    public static XpressPriorityTypeList: Array<any> = [
        { name: 'Low', value: XpressPriorityType.Low },
        { name: 'Lowest', value: XpressPriorityType.Lowest },
        { name: 'Medium', value: XpressPriorityType.Medium },
        { name: 'High', value: XpressPriorityType.High },
        { name: 'Highest', value: XpressPriorityType.Highest },
    ];
}
